import React, { Component } from 'react';
import Button from '../../components/Button';
import './WorkerCard.css';
import { HOST } from '../../constants/Fetch'
import Preloader from '../Preloader';
import ErrorMessage from '../ErrorMessage';
import PropTypes from 'prop-types';
import { FormSubscribe } from '../../components/Form';
import { Link } from 'react-router-dom';

// IE detect
let isIE = false;
if (typeof(document) !== 'undefined') {
  isIE = false || !!document.documentMode;
}

class WorkerCard extends Component {
  static contextTypes = {
    width: PropTypes.number
  };

  render() {
    const worker = this.props.worker;
    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }
    return (
      <div className={`workerCard row ${this.props.inVacancy ? 'workerCard--inVacancy' : ''}`}>
        <div className={`col colVertTablet--12 ${worker.image && 'col--6'}`}>
          <div className="workerCard__info">
            { (!this.props.inVacancy && !worker.company === undefined)&&
              [
                <img className="workerCard__logo" src={HOST + worker.company.logo} alt={worker.company.name} key='workerCard-logoKey' />,
                <div className="workerCard__company" key='workerCard-logoCompany'>{worker.company.name}</div>
              ]
            }
            <div className="workerCard__name">{worker.first_name} {worker.last_name}</div>
            {
              worker.text_vacancy &&
              <div className="workerCard__position">{worker.text_vacancy}</div>
            }
            {
              (worker.city && !(worker.city === undefined)) &&
              <div className="workerCard__addInfo text">Город {worker.city.name}</div>
            }
            {
               worker.history &&
              <div className="workerCard__quote text" dangerouslySetInnerHTML={{ __html: worker.history }}></div>
            }
          </div>
          {
            !this.props.inVacancy &&
            (
              (worker.vacancy && worker.vacancy.length > 0) ?
              <div className="workerCard__footer">
                <div className="text text--h3">У нас есть открытая вакансия</div>
                <div className="text text--bottom24">На должность <Link to={`../vacancies/vacancy${worker.vacancy[0].id}`}>{worker.vacancy[0].name}</Link> в вашем городе</div>
                <Button modifier="button--xs button--marginBottom" class="goal101" text="Откликнуться" smooth link={`../vacancies/vacancy${worker.vacancy[0].id}/#toResumeFormInVacancy`} />
              </div> :
              <div className="workerCard__footer">
                <div className="text text--h3">Уведомить меня</div>
                  <div className="text text--bottom16">О появлении вакансий
                  {
                    worker.scope_activity &&
                    <React.Fragment>
                      <span className="text text--lateral">в сфере <strong>«{worker.scope_activity.name}»</strong></span>
                    </React.Fragment>
                  }
                </div>
                <FormSubscribe apiUrl='/vacancy/vacancy-subscriber/' city={this.props.baseCity} activity={worker.scope_activity} selectCity={true} />
              </div>
            )
          }
        </div>
        {
          worker.image &&
          <div className="col col--6 colVertTablet--12 colOrderVertTablet---1">
            <div className={`workerCard__arrowWrapper ${isIE && 'workerCard__arrowWrapper--background'}`} style={{ backgroundImage:  `url(${ + this.context.width > 800 ? HOST + worker.image : HOST + worker.image_crop})` }}>
              <img
                className="workerCard__photo"
                src={HOST + `${this.context.width > 800 ? worker.image : worker.image_crop}`}
                alt={`${worker.first_name} ${worker.last_name}`} />
            </div>
          </div>
        }
      </div>
    );
  }
}

export default WorkerCard;



// WEBPACK FOOTER //
// ./src/components/WorkerCard/index.js